export const HIKESCOMMENTS = [
    {
        id: 0,
        hikeId: 0,
        text: 'It was an amazing hike!'
    },
    {
        id: 1,
        hikeId: 0,
        text: 'Train is even better the second time!'
    },
    {
        id: 2,
        hikeId: 1,
        text: 'Love this trail!'
    },
    {
        id: 3,
        hikeId: 1,
        text: 'Trail is all washed out now...'
    },
    {
        id: 4,
        hikeId: 2,
        text: 'So glad i found this trail!'
    },
    {
        id: 5,
        hikeId: 2,
        text: 'They made some great improvements to the trail!'
    },
]